<template>
  <div class="school-admin-teachers">
      <PreLoader v-if="isLoading"/>
      <SuperAdminSchoolHead style="align-items: flex-start" class="sas-head">
            <template v-slot:title><span class="sas-title">{{ $t('teachers') }}</span></template>
            <template v-slot:center>
                <div class="sas-head-center">
                    <div class="sas-head-center-block">
                        <v-select outlined dense :items="filterSchoolCourses" item-text="courseTitle"
                                  item-value="courseCode" :label="$t('subjectFilter')" class="select-course"
                                  @change="filterByCourse" :no-data-text="$t('no_data')"/>
                        <div class="excel-btn-mob" style="width: 50%">
                            <ExcelJs :rows="exportRows" :button-title="$t('export')"
                                     :file-name="exportName" :headers="exportHeaders"/>
                        </div>
                    </div>
                    <div class="sas-head-center-block">
                        <v-text-field outlined dense v-model="search['query']" @keyup.enter="searchTeacherByFIO"
                                      @input="search.query !== '' ? showIcon = true : showIcon = false"
                                      prepend-inner-icon="mdi-magnify" style="margin: 0;"
                                      :append-icon="!showIcon ? '' : 'mdi-close'" @click:append="clearSearch"/>
                        <v-btn color="primary" style="height: 40px; margin: 0" class="text-no-wrap"
                               @click="searchTeacherByFIO">
                            {{$t("search")}}
                        </v-btn>
                    </div>
                </div>
            </template>
            <template v-slot:right>
                <div class="export-custom">
                <v-btn @click="generateLoginPassword(true)" color="primary" style="height: 40px; margin: 0;">
                    {{$t('generateLoginAndPas')}}
                </v-btn>
                    <div class="excel-btn-des">
                        <ExcelJs :rows="exportRows" :button-title="$t('export')" :file-name="exportName"
                                 :headers="exportHeaders"/>
                    </div>
                </div>
            </template>
        </SuperAdminSchoolHead>
      <div style="margin: 0; padding: 20px 10px">
          <SmartTable :schools="instructors" :total-elements="totalElements" :totalPages="totalPages"
                      :page-size="pageSize" :current-page="currentPage"
                      @leftClick="onLeftClick" @rightClick="onRightClick">
              <template v-slot:head>
                  <th>№</th>
                  <th>{{ $t('full_name') }}</th>
                  <th>{{ $t('course') }}</th>
                  <th>Логин</th>
                  <td @click="onAddAdmin" class="actions"><img alt="" src="../../assets/images/icons/plus.svg"></td>
              </template>

              <template v-slot:body="{ item }">
                  <td>{{ (currentPage - 1) * 10 + item.index + 1 }}</td>
                  <td style="min-width: 200px">{{ item.lastName+' '+item.firstName+' '+checkMiddleName(item.middleName)}}</td>
                  <td class="instr-courses">{{ translateCourses(item.courses) }}</td>
                  <td>{{ item.username }}</td>
                  <td style="padding: 15px" @click="editUser(item)" class="actions"><img style="min-width: 15px;" alt="" src="../../assets/images/icons/pen.svg"></td>
                  <!--                <td><CourseIcon @click="addCourseModal(item.id, false)"/></td>-->
                  <td style="padding: 15px"><TrashIcon @click="deleteTeacher(item, true)"/></td>
              </template>
          </SmartTable>
      </div>
        <v-dialog v-if="isAddUser" id="add-form" v-model="isAddUser" width="800">
            <AddTeacher :is-edit="isEdit" :user="user" @close="onCloseModal" @hide="isAddUser=false"/>
        </v-dialog>
        <v-dialog v-if="isAddFile" v-model="isAddFile" width="546" id="add-file">
            <ImportFile ref="importFile" :type="'teachers'" @submit="onSubmit"/>
        </v-dialog>
      <v-dialog v-model="teachDeleteDialog">
          <v-card style="padding: 8px; max-width: 500px; margin: 0 auto">
              <v-card-text v-html="$t('areYouSureToDelete')" style="font-size: 18px; text-align: center"></v-card-text>
              <v-card-actions>
                  <div style="display: flex; flex-direction: row; width: 100%; justify-content: space-between">
                      <v-btn color="primary" @click="teachDeleteDialog = false">{{ $t('cancel') }}</v-btn>
                      <v-btn color="red" style="color: #FFFFFF" @click="deleteTeacher('', '')">{{ $t('remove') }}</v-btn>
                  </div>
              </v-card-actions>
          </v-card>
      </v-dialog>
      <v-dialog v-model="generateTechLogAndPas">
          <v-card style="padding: 8px; max-width: 500px; margin: 0 auto">
              <v-card-text v-html="$t('areYouSureToGenerateLogin&Password')" style="font-size: 18px; text-align: center"></v-card-text>
              <v-card-actions>
                  <div style="display: flex; flex-direction: row; width: 100%; justify-content: space-between">
                      <v-btn color="primary" @click="generateTechLogAndPas=false">
                          {{ $t('cancel') }}
                      </v-btn>
                      <v-btn color="red" style="color: #FFFFFF" @click="generateLoginPassword('')">{{ $t('yes') }}</v-btn>
                  </div>
              </v-card-actions>
          </v-card>
      </v-dialog>

        <!--ADD COURSE MODAL-->
<!--        <modal name="add-course-modal" width="700px" height="auto" :clickToClose="false">-->
<!--            <div class="modal-container">-->
<!--                <div class="course-content">-->
<!--                    <div class="added">-->
<!--                        <h4>Добавленные:</h4>-->
<!--                        <div class="teacher-courses">-->
<!--                            <div class="course" v-for="(instrCourse, i) in teacherCourses" :key="i">-->
<!--                                <span>{{ instrCourse[langObj[currentLang]] }}</span>-->
<!--                                <DeleteIcon @click="deleteTeacherCourse(instrCourse.id, i)"/>-->
<!--                            </div>-->
<!--                        </div>-->
<!--                    </div>-->
<!--                    <div class="add-new">-->
<!--                        <v-form ref="addCourseForm">-->
<!--                        <div>-->
<!--                            <v-select :rules="required" :items="schoolCourses" :item-text="getLocaleCourseTitle"-->
<!--                                      item-value="id" :label="$t('addCourse')" v-model="addTeacherCourse.courseId"/>-->
<!--                        </div>-->
<!--                        <div class="btn-actions">-->
<!--                            <v-btn color="red" @click="$modal.hide('add-course-modal')" v-if="!initialAddCourse">-->
<!--                                {{ $t('cancel') }}-->
<!--                            </v-btn>-->
<!--                            <v-btn color="green" @click="submitAddTeacherCourse">{{ $t('save') }}</v-btn>-->
<!--                        </div>-->
<!--                        </v-form>-->
<!--                    </div>-->
<!--                </div>-->
<!--            </div>-->
<!--        </modal>-->

        <!--DELETE TEACHER MODAL-->
<!--        <modal name="delete-teacher-modal">-->
<!--            <div class="modal-container">-->
<!--                <h4 v-html="$t('areYouSureToDelete')"/>-->
<!--                <div class="btn-actions">-->
<!--                    <v-btn color="primary" @click="$modal.hide('delete-teacher-modal')">{{ $t('cancel') }}</v-btn>-->
<!--                    <v-btn color="red" @click="deleteTeacher('', '')">{{ $t('remove') }}</v-btn>-->
<!--                </div>-->
<!--            </div>-->
<!--        </modal>-->
<!--        <modal name="generate-login-password-modal" height="200px">-->
<!--            <div class="modal-container">-->
<!--                <h4 v-html="$t('areYouSureToGenerateLogin&Password')"/>-->
<!--                <div class="btn-actions">-->
<!--                    <v-btn color="primary" @click="$modal.hide('generate-login-password-modal')">-->
<!--                        {{ $t('cancel') }}-->
<!--                    </v-btn>-->
<!--                    <v-btn color="red" @click="generateLoginPassword('')">{{ $t('yes') }}</v-btn>-->
<!--                </div>-->
<!--            </div>-->
<!--        </modal>-->
    </div>
</template>

<script>
import SuperAdminSchoolHead from '@/components/super-admin/schools/SuperAdminSchoolHead'
import SmartTable from '@/components/table/SmartTable'
import { InstructorCourseService } from '@/_services/instructor-course.service'
import AddTeacher from '@/components/teacher/AddTeacher'
import { PersonService } from '@/_services/person.service'
import ExcelJs from '@/components/excel-export/ExcelJs'
import ImportFile from '@/components/import-file/ImportFile'
import { FileImportService } from '@/_services/file-import.service'
import InstructorService from '@/_services/instructor.service'
import PreLoader from '@/components/preloader/PreLoader'
import TrashIcon from '@/components/icons/TrashIcon'
import { CourseService } from '@/_services/course.service'
const fileImportService = new FileImportService()
const personService = new PersonService()
const instructorCourseService = new InstructorCourseService()
const courseService = new CourseService()

export default {
  name: 'Teachers',
  components: {
    PreLoader,
    ImportFile,
    ExcelJs,
    TrashIcon,
    AddTeacher,
    SuperAdminSchoolHead,
    SmartTable
  },
  data: () => ({
    langObj: {
      ru: 'courseTitle',
      kg: 'courseTitleKG',
      en: 'courseCode'
    },
    required: [v => !!v || this.$t('Обязательное поле')],
    isAddUser: false,
    instructors: [],
    user: { pin: '' },
    isEdit: false,
    showIcon: false,
    exportName: '',
    exportRows: [],
    exportHeaders: [],
    isAddFile: false,
    totalElements: 0,
    pageSize: 0,
    currentPage: 1,
    isLoading: false,
    teachDeleteDialog: false,
    generateTechLogAndPas: false,
    schoolCourses: [],
    allSchoolCourses: [],
    filterSchoolCourses: [],
    teacherCourses: [],
    totalPages: 1,
    addTeacherCourse: {
      archived: false,
      courseId: 0,
      personId: 0,
      schoolId: 0
    },
    selectedCourseCode: '',
    deleteTeacherId: '',
    search: {
      query: ''
    },
    initialAddCourse: false
  }),
  computed: {
    userProfile () {
      return this.$store.state.account.profile
    },
    school () {
      return this.userProfile.schools[0]
    },
    currentLang () {
      return this.$root.$i18n.locale
    }
  },
  async mounted () {
    this.addTeacherCourse.schoolId = this.userProfile.schools[0].id
    this.fetchInstructors()
    this.fetchSchoolCourses()
  },
  methods: {
    fetchInstructors (page = 0, size = 10) {
      this.isLoading = true
      this.instructors = []
      InstructorService.list(
        page,
        this.school.id,
        this.selectedCourseCode,
        size,
        this.search.query
      ).then((res) => {
        this.totalPages = res.page.totalPages
        this.totalElements = res.page.totalElements
        this.pageSize = res.page.size
        this.currentPage = res.page.number + 1
        if (res._embedded) {
          this.instructors = res._embedded.instructorResourceList.map((teacher, i) => ({ ...teacher, index: i }))
        }
        this.exportHeaders = [this.$t('full_name'), this.$t('gender'), 'Логин', 'Пароль', this.$t('birthDate'), 'Телефон', this.$t('gender')]
        this.exportRows = this.instructors.map((i) => {
          // eslint-disable-next-line no-return-assign
          return [
            i.lastName + ' ' + i.firstName + ' ' + this.checkMiddleName(i.middleName),
            this.translateCourses(i.courses),
            i.username,
            i.username,
            i.birthDay,
            i.phone,
            i.gender = i.gender === 'MALE' ? 'M' : 'Ж'
          ]
        })
        this.exportName = 'Умная школа: Учителя'
        this.isLoading = false
      }).catch(err => {
        this.$toast.error(err)
        this.isLoading = false
      })
    },

    filterByCourse (courseCode) {
      this.search.query = ''
      this.currentPage = 1
      if (courseCode) {
        this.selectedCourseCode = courseCode
        this.fetchInstructors(0)
      } else {
        this.selectedCourseCode = ''
        this.fetchInstructors(0, 10)
      }
    },

    translateCourses (courses) {
      const translatedArr = []
      courses.forEach((course) => {
        translatedArr.push(course[this.langObj[this.currentLang]] === null ? this.$t('notTranslate') : course[this.langObj[this.currentLang]])
      })
      return translatedArr.join(', ')
    },

    checkMiddleName (middleName) {
      return middleName || ''
    },

    fetchSchoolCourses () {
      courseService.listBySchool(this.userProfile.schools[0].id).then((res) => {
        if (res.totalElements) {
          courseService.listBySchool(this.userProfile.schools[0].id, '', 0, res.totalElements).then((result) => {
            this.schoolCourses = result.content
            this.allSchoolCourses = result.content
            this.filterSchoolCourses = JSON.parse(JSON.stringify(result.content.sort((a, b) =>
              a.courseTitle.localeCompare(b.courseTitle))))
            this.filterSchoolCourses.unshift({ courseCode: 0, courseTitle: this.$t('showAll') })
          })
        }
        this.filterSchoolCourses.unshift({ courseTitle: this.$t('showAll'), courseCode: '' })
      })
    },

    getLocaleCourseTitle (courseObj) {
      return courseObj[this.langObj[this.currentLang]]
    },

    clearSearch () {
      this.showIcon = false
      this.search.query = ''
      this.searchTeacherByFIO()
    },
    searchTeacherByFIO () {
      this.currentPage = 1
      this.selectedCourseCode = ''
      this.fetchInstructors()
    },

    onAddAdmin () {
      this.isAddUser = true
      this.isEdit = false
      this.user = {}
    },
    onCloseModal (instructorId) {
      this.isAddUser = false
      if (this.isEdit) {
        personService.getById(this.user.id).then((res) => {
          this.instructors = this.instructors.map((instructor) => {
            if (instructor.id === res.id) {
              for (const key in res) {
                // eslint-disable-next-line no-prototype-builtins
                if (res.hasOwnProperty(key) && instructor.hasOwnProperty(key)) {
                  instructor[key] = res[key]
                }
              }
            }
            return instructor
          })
        })
      } else {
        if (instructorId) {
          this.addCourseModal(instructorId, true)
        }
      }
    },
    downloadTemplate () {
      const a = document.createElement('a')
      a.download = 'Шаблон импорта учителя.xlsx'
      a.href = '/docs/Шаблон_Мугалим.xlsx'
      a.click()
    },

    editUser (item) {
      personService.getById(item.id).then(res => {
        this.user = {
          id: res.id,
          name: res.firstName,
          surname: res.lastName,
          middleName: res.middleName,
          gender: res.gender,
          phone: res.phone ? res.phone.replace('+', '') : '',
          courseId: item.courseId,
          pin: res.pin,
          dob: res.dateOfBirth,
          userId: res.userId,
          username: item.username
        }
        this.isAddUser = true
        this.isEdit = true
      }).catch(err => console.log(err))
    },
    onSubmit (data) {
      if (this.$refs.importFile.$refs.importForm.validate()) {
        this.isLoading = true
        const d = {
          languageId: data.languageId,
          chronicleId: data.chronicleId,
          file: data.file,
          schoolId: this.userProfile.schools[0].id
        }
        if (data.isIsouMode) {
          fileImportService.importIsouInstructor(d).then(res => {
            this.$toast.success(this.$t('success'))
            this.isAddFile = false
            this.fetchInstructors()
            this.isLoading = false
          }).catch(err => {
            this.isLoading = false
            console.log(err)
          })
        } else {
          fileImportService.importInstructor(d).then(res => {
            this.$toast.success(this.$t('success'))
            this.isAddFile = false
            this.fetchInstructors()
            this.isLoading = false
          }).catch(err => {
            this.isLoading = false
            console.log(err)
          })
        }
      }
    },
    onLeftClick () {
      this.currentPage--
      this.fetchInstructors(this.currentPage - 1)
    },
    onRightClick () {
      this.currentPage++
      this.fetchInstructors(this.currentPage - 1)
    },

    addCourseModal (instructorId, bool) {
      this.initialAddCourse = bool
      this.isLoading = true
      this.addTeacherCourse.courseId = ''
      this.addTeacherCourse.personId = instructorId
      this.schoolCourses = this.allSchoolCourses
      instructorCourseService.listByInstructor(instructorId).then((res) => {
        this.teacherCourses = res._embedded ? res._embedded.instructorCourseResourceList : []
        if (this.teacherCourses.length) {
          this.teacherCourses = this.teacherCourses.map((course) => {
            course.courseCode = course.courseName
            return course
          })
          const existCourses = this.teacherCourses.map(course => course.courseId)
          existCourses.forEach((existCourseId) => {
            this.schoolCourses = this.schoolCourses.filter(course => course.id !== existCourseId)
          })
        }
        this.isLoading = false
        this.$modal.show('add-course-modal')
      }).catch((err) => {
        this.$toast.error(err)
        this.isLoading = false
      })
    },

    submitAddTeacherCourse () {
      if (this.$refs.addCourseForm.validate()) {
        this.isLoading = true
        instructorCourseService.create(this.addTeacherCourse).then(() => {
          this.fetchInstructors()
          this.isLoading = false
          this.$toast.success('Успешно добавлено!')
          this.$modal.hide('add-course-modal')
        }).catch((err) => {
          this.$toast.error(err)
          this.isLoading = false
        })
      }
    },

    deleteTeacher (teacher, confirm) {
      if (confirm) {
        this.deleteTeacherId = teacher.id
        this.$modal.show('delete-teacher-modal')
        this.teachDeleteDialog = true
      } else {
        this.isLoading = true
        InstructorService.deleteInstructor(this.deleteTeacherId).then(() => {
          this.$modal.hide('delete-teacher-modal')
          this.teachDeleteDialog = false
          this.$toast.success(this.$t('successDeleted'))
          this.filterByCourse(this.selectedCourseCode)
        }).catch((err) => {
          this.$toast.error(err)
          this.isLoading = false
        })
      }
    },

    deleteTeacherCourse (instrCourseId, index) {
      this.isLoading = true
      instructorCourseService._delete(instrCourseId).then(() => {
        this.isLoading = false
        this.teacherCourses.splice(index, 1)
        this.$toast.success(this.$t('successDeleted'))
        this.fetchInstructors()
      }).catch((err) => {
        this.$toast.error(err)
        this.isLoading = false
      })
    },

    generateLoginPassword (confirm) {
      if (confirm) {
        this.generateTechLogAndPas = true
        // this.$modal.show('generate-login-password-modal')
      } else {
        this.isLoading = true
        InstructorService.generateLoginPassword(this.userProfile.schools[0].id).then(() => {
          this.generateTechLogAndPas = false
          // this.$modal.hide('generate-login-password-modal')
          this.$toast.success('Успешно сгенерировано!')
          this.filterByCourse(this.selectedCourseCode)
        }).catch((err) => {
          this.$toast.error(err)
          this.isLoading = false
        })
      }
    }
  }
}
</script>

<style lang="scss">
.sas-head-center {
    display: flex;
    gap: 8px;
    margin: 0!important;
}
.sas-head-center-block{
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    flex-wrap: nowrap;
    gap: 8px;
    margin: 0!important;
    padding: 0!important;
}
.v-dialog{
    width: max-content;
}
    .school-admin-teachers {
        margin-bottom: 50px;
        .select-course {
            margin: 0!important;
        //    max-width: 185px;
        }
        .v-btn__content {
            color: #fff;
        }
        .instr-courses {
            width: 400px;
            min-width: 200px;
        }
        .modal-container {
            .course-content {
                display: flex;
                align-items: center;
                justify-content: center;
                .added {
                    border-right: 2px solid #9E9E9E;
                    margin-right: 20px;
                    padding-right: 20px;
                    min-width: 50%;
                    max-height: 370px;
                    overflow-y: auto;
                }
                .add-new {
                    min-width: 50%;
                }
                .teacher-courses {
                    text-align: center;
                    transform: translateY(-10px);
                    .course {
                        margin-bottom: 8px;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        border-bottom: 1px solid #eee;
                    }
                    .delete-icon {
                        width: 22px;
                        min-width:  22px;
                        height: 22px;
                        margin-left: 10px;
                    }
                }
            }
        }
    }
    .export-custom{
        display: flex;
        flex-direction: row;
        gap: 8px!important;
        margin: 0;
        padding: 0!important;
    }

    @media (max-width: 768px) {
        .sas-head-center-block{
            width: 100%;
        }
        .sas-btn{
            display: flex;
        }
        .sas-head{
            flex-wrap: wrap;
            margin: 0!important;
            align-items: center;
            justify-content: center!important;
        }
        .sas-head-center {
            flex-wrap: wrap-reverse;
            justify-content: center;
            padding: 0;
            gap: 0;
        }
        .sas-title {
            font-size: 20px!important;
            margin-bottom: 15px;
            margin-top: 25px;
            text-align: center;
            width: 100%;
        }
        .export-custom{
            flex-wrap: wrap;
            //padding: 12px 0;
            margin: 0;
            width: 100%;
        }
        .select-course {
            width: 100%;
            max-width: 198px;
            //max-width: 180px;
        }
        .v-btn__content{
            font-size: 11px!important;
        }
    }
</style>
